import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { ROUTE_NAMES } from "./routenames";
import Home from "../views/Home.vue";
import MeasuresView from "../views/MeasuresView.vue";
import FindingTypesView from "../views/FindingTypesView.vue";
import MeasureTypesView from "../views/MeasureTypesView.vue";
import MeasuresDueDateView from "../views/MeasuresDueDateView.vue";
import AverageProcessingTimeView from "../views/AverageProcessingTimeView.vue";

// route level code-splitting
// this generates a separate chunk (audit.[hash].js) for this route
// which is lazy-loaded when the route is visited.
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue");

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/",
    name: ROUTE_NAMES.DASHBOARD,
    component: Dashboard
  },
  {
    path: "/home",
    name: ROUTE_NAMES.HOME,
    component: Home
  },
  {
    path: "/dashboard",
    name: ROUTE_NAMES.DASHBOARD,
    component: Dashboard
  },
  {
    path: "/measures",
    name: ROUTE_NAMES.MEASURES,
    component: MeasuresView
  },
  {
    path: "/averageProcessingTime",
    name: ROUTE_NAMES.AVERAGE_PROCESSING_TIME,
    component: AverageProcessingTimeView
  },
  {
    path: "/findingTypes",
    name: ROUTE_NAMES.FINDING_TYPES,
    component: FindingTypesView
  },
  {
    path: "/measureTypes",
    name: ROUTE_NAMES.MEASURE_TYPES,
    component: MeasureTypesView
  },
  {
    path: "/measuresDueDate",
    name: ROUTE_NAMES.MEASURES_DUE_DATE,
    component: MeasuresDueDateView
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "is-active"
});

export default router;
